// extracted by mini-css-extract-plugin
export var layoutContainer = "_9b-0";
export var layoutContainerNoRounding = "_9b-6";
export var layoutContainerOpen = "_9b-5";
export var layoutContainerResizing = "_9b-1";
export var mainContent = "_9b-2";
export var resizeDivider = "_9b-3";
export var slidePanel = "_9b-4";